export default __webpack_public_path__ + "img/error/503.svg";